const CASH_BOX_WARNING_PREFIXES = [
  '/apps/PayDetection',
  '/apps/ParkingOccupancy',
  '/apps/gate-control',
  '/apps/manual-invoice',
  '/apps/CashMovements',
  '/apps/CashBoxes',
  '/apps/CashClosingDetail',
  '/apps/customer-account',
  '/apps/billing-suggestions',
];

function normalizePath(url: string): string {
  return (url ?? '').split('?')[0].split('#')[0];
}

function matchesPrefix(path: string, prefix: string): boolean {
  return path === prefix || path.startsWith(`${prefix}/`);
}

/** Pantallas donde un cobro o una salida dependen de una caja abierta. */
export function isCashBoxWarningRoute(url: string): boolean {
  const path = normalizePath(url);
  if (!path) {
    return false;
  }
  if (CASH_BOX_WARNING_PREFIXES.some((prefix) => matchesPrefix(path, prefix))) {
    return true;
  }
  if (path === '/apps/customers') {
    return true;
  }
  if (path.startsWith('/apps/customers/view/')) {
    return true;
  }
  const account = /^\/apps\/customers\/([^/]+)\/account$/.exec(path);
  return !!account && account[1] !== 'add' && account[1] !== 'edit';
}
